import { render, staticRenderFns } from "./Hubspots.vue?vue&type=template&id=5bb88fa4&scoped=true"
import script from "./Hubspots.vue?vue&type=script&lang=js"
export * from "./Hubspots.vue?vue&type=script&lang=js"
import style0 from "./Hubspots.vue?vue&type=style&index=0&id=5bb88fa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb88fa4",
  null
  
)

export default component.exports